import { AxiosError } from 'axios'
import { defineStore } from 'pinia'
export interface ServiceState {
  expandQuestionList: number[]
  /**访问客服接口报错时候的错误对象 */
  serviceAxiosError: AxiosError | null
  /**客服接口的载入状态 */
  loading: boolean
}

export const useServiceStore = defineStore('service', {
  state: (): ServiceState => ({
    expandQuestionList: [],
    serviceAxiosError: null,
    loading: false
  }),

  actions: {
    setExpandQuestionList(list: number[]) {
      this.expandQuestionList = list
    },
    setServiceAxiosError(serviceAxiosError: AxiosError | null) {
      this.serviceAxiosError = serviceAxiosError
    },
    setLoading(loading: boolean) {
      this.loading = loading
    }
  }
})
